import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-line" data-id="element-75" data-mp="1dqrohw3lfk7t">
      <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-3 px-5 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-10 lg:px-10" data-id="element-76" data-mp="3r7pv1qpfy31v">
        <p className="font-mono text-[11px] tracking-tight text-white/40 sm:text-[12px]" data-id="element-77" data-mp="3mfg90lrg5n4v">
          indicadoresvip.com © 2026 - Todos los derechos reservados.
        </p>
        <p className="max-w-md text-[11px] leading-relaxed text-white/25" data-id="element-78" data-mp="3dhmffil2h7le">
          El trading de instrumentos apalancados conlleva riesgo. Los resultados
          pasados no garantizan rendimientos futuros.
        </p>
      </div>
    </footer>;
}